export const GRATUITY_INITIAL_STATE = {
    gratuity_act_no: '',
    coverage_date: '',
    gratuity_type: '',
    orgId:'',
    status: true
}